import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {PaymentMoment} from '../../../../model/payment-moment';
import {LocalizedText} from '../../../../model/localized-text';
import {FormatService} from '../../../../services/format.service';
import { UpperCasePipe, DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'myabvv-allowances-overview-list-by-date',
    standalone: true,
    templateUrl: './allowances-overview-list-by-date.component.html',
    styleUrls: ['./allowances-overview-list-by-date.component.css'],
    imports: [UpperCasePipe, DatePipe, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllowancesOverviewListByDateComponent implements OnInit {
  private formatService = inject(FormatService);

  @Input() paymentsOverview: PaymentMoment[];
  @Output() selectPaymentEvent = new EventEmitter();

  ngOnInit() {
  }

  onSelectAllowanceItem(paymentMoment: PaymentMoment) {
    this.selectPaymentEvent.emit(paymentMoment);
  }

  getTranslatedData(array: LocalizedText[]): string {
    return this.formatService.getTranslatedData(array);
  }

  getTranslatedMonth(dateToFormat: string): string {
    return this.formatService.formatDate(`${dateToFormat}-01`);
  }

  getCurrency(currency: string): string {
    return this.formatService.formatCurrency(currency);
  }

  sumUnemploymentGrossAmount(paymentMoment: PaymentMoment) {
    let grossAmount = 0.0;
    paymentMoment.paymentCalculations.forEach(calculation => {
      grossAmount += Number(calculation?.unemploymentInfo?.unemploymentGrossAmount);
    });
    return this.formatService.formatNumber(grossAmount);
  }

  sumUnemploymentDays(paymentMoment: PaymentMoment) {
    let days = 0.0;
    paymentMoment.paymentCalculations.forEach(calculation => {
      days += Number(calculation?.unemploymentInfo?.unemploymentDays);
    });
    return this.formatService.formatNumber(days, 1);
  }

  sumAdditionalCompensationGrossAmount(paymentMoment: PaymentMoment) {
    let grossAmount = 0.0;
    paymentMoment.paymentCalculations.forEach(calculation => {
      grossAmount += Number(calculation?.additionalCompensation?.additionalCompensationGrossAmount);
    });
    return this.formatService.formatNumber(grossAmount);
  }

  sumAdditionalCompensationDays(paymentMoment: PaymentMoment) {
    let days = 0.0;
    paymentMoment.paymentCalculations.forEach(calculation => {
      days += Number(calculation?.additionalCompensation?.additionalCompensationDays);
    });
    return this.formatService.formatNumber(days, 1);
  }

}
